<script setup lang="ts">
import { useAuthorImageUrl } from '@shared/app/composables/useAuthorImageUrl';
import type { Author } from '@shared/app/utils/transformToAuthor';

defineProps<{
  author: Author;
}>();

const { createAuthorImageUrl } = useAuthorImageUrl();
</script>

<template>
  <div>
    <h2 class="text-brown-300 text-xl font-bold mb-3">このレシピの作者</h2>

    <div class="flex gap-5 items-center mb-3">
      <div class="w-16 h-16 shrink-0 rounded-full overflow-hidden">
        <img
          v-if="author.profile_image"
          :src="
            createAuthorImageUrl({
              authorId: author.id,
              filename: author.profile_image,
              w: 100,
              h: 100,
            })
          "
          class="w-full h-full object-cover"
        />
        <AtomsPlaceholderImage class="w-full h-full object-cover bg-white" />
      </div>

      <div>
        <p v-if="author.title" class="font-bold text-pink-400">
          {{ author.title }}
        </p>
        <NuxtLink
          v-if="author.active"
          :to="`/public/article/recipe/authors/${author.id}`"
          class="text-xl font-bold text-gray-500 underline"
        >
          {{ author.name }}
        </NuxtLink>
        <p v-else class="text-xl font-bold text-gray-500">
          {{ author.name }}
        </p>
      </div>
    </div>

    <p class="text-gray-500 text-lg">
      {{ author.description }}
    </p>

    <AtomsAuthorUrlList :urls="author.urls" />
  </div>
</template>
